// src/services/CommentAdminService.js

import http from "./httpService";

class PostLogAdminService {
  async getAll(params) {
    const url = http.getUrlWithParams("/admin/postactivity", params);
    return await http.get(url);
  }
}

export default new PostLogAdminService();
